import React from 'react';
import PropTypes from 'prop-types';
import { EmailIcon } from '@domain-group/fe-co-icon';
import { Button, CallButton } from '@domain-group/fe-co-allhomes-design-system';
import { AllhomesNonEuUser } from '@domain-group/fe-co-allhomes-eu-user';
import * as styles from './footer-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var FooterCard = props => ___EmotionJSX("div", {
  className: props.className,
  css: styles.footerCard
}, ___EmotionJSX("div", {
  css: styles.topSection
}, ___EmotionJSX("div", {
  css: styles.profilePhotoContainer
}, props.images && props.images.profilePhoto && ___EmotionJSX("img", {
  src: props.images.profilePhoto,
  alt: props.name,
  css: styles.profilePhoto
}))), props.address && ___EmotionJSX("div", null, ___EmotionJSX("div", {
  css: styles.name
}, props.name), ___EmotionJSX("div", {
  css: styles.middleTextContainer
}, ___EmotionJSX("span", {
  css: styles.addressLine1
}, props.address.street, ",\xA0"), ___EmotionJSX("span", null, props.address.suburb, "\xA0", props.address.state, "\xA0", props.address.postcode))), ___EmotionJSX("div", {
  css: styles.bottomSectionContainer
}, ___EmotionJSX("div", {
  css: styles.buttons
}, props.phone && ___EmotionJSX(CallButton, {
  phone: props.phone,
  css: styles.phoneButton,
  onClick: () => {
    if (props.eventHandlers.callButtonClicked) {
      props.eventHandlers.callButtonClicked();
    }
  }
}), ___EmotionJSX(AllhomesNonEuUser, null, props.emailContactable && ___EmotionJSX(Button, {
  css: styles.emailButton,
  appearance: "primary",
  icon: ___EmotionJSX(EmailIcon, null),
  onClick: () => {
    if (props.eventHandlers.contactClicked) {
      props.eventHandlers.contactClicked();
    }
  }
}, "Email")))));
FooterCard.propTypes = {
  name: PropTypes.string,
  phone: PropTypes.string,
  emailContactable: PropTypes.bool,
  images: PropTypes.shape({
    profilePhoto: PropTypes.string,
    coverPhoto: PropTypes.string
  }),
  address: PropTypes.shape({
    street: PropTypes.string.isRequired,
    suburb: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    postcode: PropTypes.string.isRequired,
    lat: PropTypes.number,
    lng: PropTypes.number
  }),
  eventHandlers: PropTypes.shape({
    callButtonClicked: PropTypes.func,
    contactClicked: PropTypes.func
  }),
  className: PropTypes.string
};
FooterCard.defaultProps = {
  name: '',
  phone: '',
  emailContactable: true,
  eventHandlers: {},
  images: null,
  address: null,
  className: ''
};
export default FooterCard;